import {del, patch, post} from "./http_client";
import {api_user_path, api_users_path} from "../routes";

export const create = (params) => post({url: api_users_path(), params: {user: params}})
export const destroy = (sub) => del({url: api_user_path(sub.id)})
export const update = (sub, params) => patch({url: api_user_path(sub.id), params: {user: params}})